import { render, staticRenderFns } from "./ReceivableInfo.vue?vue&type=template&id=30aef60c"
import script from "./ReceivableInfo.vue?vue&type=script&lang=js"
export * from "./ReceivableInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports